import { Component, Renderer2 } from "@angular/core";
import { MailBoxService } from "./service/mailbox.service";
import { SharedService } from "./service/shared.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent {
  constructor(
    private readonly mailboxService: MailBoxService,
    private readonly sharedService: SharedService,
    private readonly renderer: Renderer2
  ) {
    this.mailboxService.initOfficeJS();

    let isOnAndroid = false;
    if (this.sharedService.officeHostName === "OutlookIOS") {
      this.renderer.addClass(document.body, "ios");
    } else if (this.sharedService.officeHostName === "OutlookAndroid") {
      isOnAndroid = true;
      this.renderer.addClass(document.body, "md");
    }
  }
}
